export default "__VITE_ASSET__CpqdxTSG__"